import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { IgAccount } from '@core/models/ApiFields/ig-entities';
import { IDateRangeAsDates } from '@core/models/IDates';
import { FiltDimension } from '@features/social-analysis/models/IFilters';
import dayjs from 'dayjs';
import { ToastService } from '@shared/services/toast.service';
import { finalize, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { ApiResIgAccount } from '@core/models/IAdmin';

@Injectable({ providedIn: 'root' })
export class PageFiltersService {
    #http = inject(HttpClient);
    #toastr = inject(ToastService);

    reqFilterOpts(state: PageFiltersState, dim: FiltDimension, search: string | null = '') {
        const { startDate, endDate } = state.selectedDates();
        if (!startDate || !endDate) return this.#toastr.error('No valid date range selected');

        const url = this.#buildUrl(dim);
        const dateParams = this.#formatDates(state.selectedDates());

        const params: Params = { ...dateParams, value: search };

        state.isLoading.set(true);
        state.opts.set([]);

        this.#http
            .get<string[] | ApiResIgAccount>(url, { params: params })
            .pipe(
                map(res =>
                    this.#isIgAccount(dim) ? this.#formatIgAccRes(res as ApiResIgAccount) : res
                ),
                finalize(() => state.isLoading.set(false))
            )
            .subscribe({
                next: res => state.opts.set(res as string[]),
                error: err => this.#toastr.error(err.error.message),
            });
    }

    #buildUrl(dim: FiltDimension) {
        const baseUrl = environment.api_base;

        if (this.#isIgAccount(dim)) return baseUrl + '/admin/instagram/account';

        const endpoint = '/insights/conf/';
        const formatDim = dim.value;
        return baseUrl + endpoint + formatDim;
    }

    #formatDates({ startDate, endDate }: IDateRangeAsDates) {
        return {
            since: dayjs(startDate)?.format('YYYY-MM-DD'),
            until: dayjs(endDate)?.format('YYYY-MM-DD'),
        };
    }

    #isIgAccount(dim: FiltDimension) {
        return dim.value === IgAccount.fields.igAccount;
    }

    #formatIgAccRes(res: ApiResIgAccount) {
        const confArr: string[] = [];
        confArr.push(res[0].ig_account);
        res[0].competitors.forEach((comp: any) => confArr.push(comp.ig_account));
        return confArr;
    }
}
